import { render, staticRenderFns } from "./FormBuilderCustomFields.vue?vue&type=template&id=6072aff6&"
import script from "./FormBuilderCustomFields.vue?vue&type=script&lang=js&"
export * from "./FormBuilderCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports